
import { ProductFamilyDto, CreateProductFamilyDto, UpdateProductFamilyDto } from '@services/dtos'
import { baseCrudReducer } from './baseCrudReducer'
import { productFamilyService } from '@services/ProductFamilyService'
import { ProductFamiliesFilters } from '@services/ProductFamilyService'
import { createAsyncThunk } from '@reduxjs/toolkit'

const { reducer, actions, thunks } = baseCrudReducer<
  ProductFamilyDto,
  CreateProductFamilyDto,
  UpdateProductFamilyDto,
  ProductFamiliesFilters
>('productFamily', productFamilyService)

export default reducer

export const { setFilters: setProductFamilyFilters } = actions

export const {
  getAll: getProductFamilies,
  create: createProductFamily,
  update: updateProductFamily,
  remove: removeProductFamily,
} = thunks

export const moveProductFamily = createAsyncThunk<
  void,
  { id: string; direction: 'up' | 'down' }
>('productFamily/move', async ({ id, direction }, { dispatch }) => {
  await productFamilyService.move(id, direction)
  await dispatch(getProductFamilies())
})